<template>
  <div class="aco-grid">
    <div class="aco-info-box">
      <subscription-filter/>
    </div>
    <div class="aco-details-box">
      <subscription-list/>
    </div>
  </div>
</template>

<script>
import SubscriptionFilter from './SubscriptionFilter'
import SubscriptionList from './SubscriptionList'

export default {
  components: {
    subscriptionFilter: SubscriptionFilter,
    subscriptionList: SubscriptionList
  }
}
</script>
